"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AffiliateConversionStatus = void 0;
var AffiliateConversionStatus;
(function (AffiliateConversionStatus) {
    AffiliateConversionStatus["Pending"] = "Pending";
    AffiliateConversionStatus["Approved"] = "Approved";
    AffiliateConversionStatus["Rejected"] = "Rejected";
})(AffiliateConversionStatus || (exports.AffiliateConversionStatus = AffiliateConversionStatus = {}));
//# sourceMappingURL=AffiliateConversionStatus.js.map